<template>
    <div class="card">
        <div class="card-header">
            Courses par clients
        </div>
        <div class="card-body p-0">
            <ProgressBar v-if="isLoading === true" mode="indeterminate" style="height: 6px"></ProgressBar>
            <DataTableBackend url="/api/clients?nombre_de_course=1" :columns="columns" table="clients" incard :perPage="5"></DataTableBackend>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            table: 'courses',
            isLoading: false,
            columns: [
                {
                    key: 'nom',
                    label: 'Nom',
                    exportable: true
                },
                {
                    key: 'courses',
                    label: 'Nombre',
                    exportable: true
                },
                {
                    key: 'recettes',
                    label: 'Recette',
                    format: 'money',
                    exportable: true
                },
                {
                    key: 'impayes',
                    label: 'Impayés',
                    format: 'money',
                    exportable: true
                },
            ]
        };
    },
    mounted() {
        // this.chartOptions = this.setChartOptions();
        // this.setChartData()
    },
    methods: {
        setChartData() {
            this.isLoading = true
            this.axios.get('/api/courses?payes_and_impayes=1').then((response) => {
                let labels = [], values = []
                for (let index = 0; index < response.data.length; index++) {
                    const element = response.data[index];
                    labels.push(element.label)
                    values.push(element.value)
                }

                this.chartData = {
                    labels: labels,
                    datasets: [
                        {
                            data: values,
                            backgroundColor: [
                                '#0C266C', 
                                '#0C966C', 
                            ],
                            hoverBackgroundColor: '#995050',
                            borderWidth: 1
                        }
                    ]
                };

                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            });
        },
        setChartOptions() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');

            return {
                plugins: {
                    legend: {
                        labels: {
                            cutout: '60%',
                            color: textColor
                        }
                    }
                }
            };
        },
    }
};
</script>